"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../styles/index");
var mergeStyles_1 = require("../utilities/mergeStyles");
/**
 * Deprecated: All class names for all Fabric icons.
 * NOTE: This is deprecated, being replaced with a getIconClassName function.
 *
 * @deprecated
 */
exports.IconClassNames = {};
var _loop_1 = function (iconName) {
    var className;
    Object.defineProperty(exports.IconClassNames, iconName, {
        get: function () {
            if (className === undefined) {
                className = mergeStyles_1.mergeStyles(index_1.DefaultFontStyles.icon, {
                    ':before': {
                        // tslint:disable-next-line:no-any
                        content: "\"" + index_1.IconCodes[iconName] + "\""
                    }
                }).toString();
            }
            return className;
        },
        enumerable: true,
        configurable: true
    });
};
// tslint:disable-next-line:forin
for (var iconName in index_1.IconCodes) {
    _loop_1(iconName);
}
//# sourceMappingURL=IconClassNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/styling/lib/classNames/IconClassNames.js
// module id = 137
// module chunks = 0